import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const getStyles = (theme: Theme) => ({
  title: {
    fontFamily: 'Source Sans Pro SemiBold',
    fontSize: '12px',
    marginRight: theme.spacing(1.5),
  },
})

type Props = {
  label: string
}

export const BulkActionsLabel: React.FC<Props> = ({ label }) => {
  const styles = getStyles(useTheme())
  return <Typography sx={styles.title}>{label}</Typography>
}
BulkActionsLabel.displayName = 'BulkActionsLabel'
